import dayjs from 'dayjs'

export const expiryTimestamps: [string, number][] = [
  ['1 day', dayjs().add(1, 'day').unix()],
  ['1 week', dayjs().add(1, 'week').unix()],
  ['1 month', dayjs().add(1, 'month').unix()],
  ['1 year', dayjs().add(1, 'year').unix()],
]

export const customMinDate = dayjs().add(5, 'minute')
export const customInitialDate = dayjs().add(5, 'minute')
